import {
CREATE_ORDER_AWARD_NOMINATION_REQUEST,
CREATE_ORDER_AWARD_NOMINATION_SUCCESS,
CREATE_ORDER_AWARD_NOMINATION_FAILURE,
CREATE_ORDER_AWARD_NOMINATION_RESET,
} from '../../../types/awards';

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
};

const createOrderAwardNominationReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ORDER_AWARD_NOMINATION_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      };

    case CREATE_ORDER_AWARD_NOMINATION_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      };

    case CREATE_ORDER_AWARD_NOMINATION_FAILURE:
      return {
        ...state,
        loading: false,
        message: "",
        error: action.payload.error,
        success: false,
      };

    case CREATE_ORDER_AWARD_NOMINATION_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default createOrderAwardNominationReducer;
